export default "__VITE_ASSET__CA$mRiJh__"